export const WAVES_BG_COLOR = "#1C2390";
